/* meegel 固定ページ用アコーディオン（旧テーマのjQuery実装をvanillaで再現）
   About(page.meegel): .cart-btn_ttl をクリック → 直後要素をトグル
   FAQ(page.faq):      .question をクリック → 直後要素をトグル
   ※本番同様、初期表示は開いた状態。クリックで開閉。 */
(function () {
  function bindToggle(selector) {
    document.querySelectorAll(selector).forEach(function (trigger) {
      var panel = trigger.nextElementSibling;
      if (!panel) return;
      trigger.style.cursor = 'pointer';
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      function toggle() {
        var isOpen = panel.style.display !== 'none';
        panel.style.display = isOpen ? 'none' : '';
        trigger.classList.toggle('close', !isOpen);
      }
      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }
  function init() {
    bindToggle('.cart-btn_ttl');
    bindToggle('.faq .question, .faq-list .question');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
